import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useSelector } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import { useParams } from 'react-router-dom'
import { SelectChangeEvent } from '@mui/material/Select'
import InputField from '../../components/common/InputField'
import { Breadcrumbs, Grid, Link, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Delai } from '../../types/delaisTypes'
import { getDelaibyId, updateDelai } from '../../redux/delais/delaisActions'
import UseAlert from '../../components/common/alert'
import DateSelector from '../../components/common/Date'
import { t } from 'i18next'

export default function DelaiUpdate() {
  const [delai, setDelai] = useState<Delai>({
    DelaiId: '',
    DateDebut: new Date(),
    DateFin: new Date(),
    ActionId: '',
  })

  const [DateDebut, setDateDebut] = useState<Date>()
  const [DateFin, setDateFin] = useState<Date>()

  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: '' as 'info' | 'success' | 'error' | 'warning',
  })

  const handleCloseAlert = () => {
    setAlert({
      ...alert,
      open: false,
    })
  }
  const dispatch: AppDispatch = useAppDispatch()
  const delaisList = useSelector((state: RootState) => state.delai.delai)
  const loading = useSelector((state: RootState) => state.delai.loading)
  const error = useSelector((state: RootState) => state.delai.error)
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  useEffect(() => {
    if (id) {
      dispatch(getDelaibyId(id))
    }
    console.log(delaisList)
  }, [dispatch, id])

  useEffect(() => {
    if (delaisList !== null) {
      setDelai({
        _id: delaisList._id,
        DelaiId: delaisList.DelaiId,
        DateDebut: delaisList.DateDebut,
        DateFin: delaisList.DateFin,
        ActionId: delaisList.ActionId,
      })
      setDateDebut(delaisList?.DateDebut)

      setDateFin(delaisList?.DateFin)
    }
  }, [delaisList])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setDelai((prevDelai) => ({
      ...prevDelai,
      [name]: value,
    }))
  }

  const handleDateChange = (dates: [Date, Date] | null) => {
    if (dates) {
      const [DateDebut, DateFin] = dates

      setDelai((prevDelai: Delai) => ({
        ...prevDelai,
        DateDebut: DateDebut,
        DateFin: DateFin,
      }))

      console.log('Selected Start Date:', DateDebut)
      console.log('Selected End Date:', DateFin)
    }
  }
  console.log(delai)
  const handleUpdateDelai = async () => {
    try {
      if (delai.DateDebut && delai._id && delai.DateFin) {
        await dispatch(
          updateDelai({
            updatedDelai: delai,
            _id: delai._id,
          })
        )
        console.log(delai)
        setAlert({
          open: true,
          message: t('alerts.delaiUpdate.success'),
          severity: 'success',
        })
      } else {
        setAlert({
          open: true,
          message: t('alerts.delaiUpdate.emptyFields'),
          severity: 'error',
        })
      }
    } catch (error: any) {
      console.error('Error updating delai:', error.message)

      setAlert({
        open: true,
        message: t('alerts.delaiUpdate.error'),
        severity: 'error',
      })
    }
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Alert severity="error">{error}</Alert>
      </Box>
    )
  }

  return (
    <div>
      <Grid marginTop={'16px'} marginBottom={'22px'}>
        <Grid item xs>
          <Breadcrumbs separator="/" aria-label="breadcrumb">
            <Link
              onClick={() => navigate(`/`)}
              color="primary"
              component="button"
            >
              Home
            </Link>
            <Link
              onClick={() => navigate(`/actiond/${delai.ActionId}`)}
              color="primary"
              component="button"
            >
              Action
            </Link>
          </Breadcrumbs>
        </Grid>
      </Grid>
      <Paper className="paper-flex-column">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px',
            width: '960px',
          }}
        >
          <Typography variant="h4" component="h4" color="">
            update Delai
          </Typography>
        </div>
        <UseAlert
          open={alert.open}
          message={alert.message}
          severity={alert.severity}
          onClose={handleCloseAlert}
        />
        <form style={{ width: '100%', marginTop: '20px' }}>
          <Stack direction="column" spacing={2}>
            <DateSelector
              placeholder={t('entityForms.datePlaceholder')}
              onDateChange={handleDateChange}
              defaultValue={[
                new Date(delai?.DateDebut || ''),
                new Date(delai?.DateFin || ''),
              ]}
            />

            <Button
              variant="contained"
              color="primary"
              onClick={handleUpdateDelai}
            >
              Modifier
            </Button>
            <Button variant="outlined" color="primary">
              Anuuler
            </Button>
          </Stack>
        </form>
      </Paper>
    </div>
  )
}
